import { CalendarClock, ChevronDown } from "lucide-react";
import { useState, type ReactNode } from "react";

/** Instalment checkout trigger — prominent gradient CTA that expands the plan picker and breakdown. */
export function FlexxiPlanCollapsible({
  children,
  label = "Pay with Instalment",
  hint = "FlexxiPlan · spread the cost monthly",
  defaultOpen = false,
}: {
  children: ReactNode;
  label?: string;
  hint?: string;
  defaultOpen?: boolean;
}) {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <div className="pt-3">
      <button
        type="button"
        className="flex w-full items-center justify-between gap-3 rounded-2xl bg-gradient-to-r from-brand-pink to-brand-blue px-4 py-3 text-left text-white shadow-lg shadow-brand-pink/25 transition hover:brightness-110 focus:outline-none focus-visible:ring-2 focus-visible:ring-white/60"
        aria-expanded={open}
        onClick={() => setOpen((v) => !v)}
      >
        <span className="flex items-center gap-3">
          <CalendarClock size={22} className="shrink-0" />
          <span>
            <span className="block text-base font-bold leading-tight">{label}</span>
            {hint ? <span className="block text-[11px] font-medium text-white/80">{hint}</span> : null}
          </span>
        </span>
        <ChevronDown size={18} className={`shrink-0 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open ? <div className="mt-3 space-y-3">{children}</div> : null}
    </div>
  );
}
